import { useMutation, useQueryClient } from "@tanstack/react-query";

import { useSession, useSessionDispatch } from "../Session/SessionContext";
import { CartQueries } from "./queries";
import { createCart, deleteCart, updateCart } from "./requests";

export const useUpdateCart = () => {
  const dispatch = useSessionDispatch();
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: updateCart,
    onSuccess: (updatedCart) => {
      dispatch({
        action: "updateCart",
        payload: updatedCart,
      });
      queryClient.setQueryData(
        CartQueries.cart(updatedCart.uuid).queryKey,
        (cart) => ({
          ...cart,
          ...updatedCart,
        }),
      );
    },
  });
};
export const useNextCartMutation = () => {
  const session = useSession();
  const cart = session.cart;

  const dispatch = useSessionDispatch();

  return useMutation({
    mutationFn: async () => {
      await deleteCart(cart.uuid);
      const response = await createCart({ venueId: cart.venueId });
      // until we move off of the reducer  and session context, we need to update the session here
      dispatch({
        action: "updateCart",
        payload: response,
      });
    },
  });
};
